import React, { PureComponent } from 'react'
import classnames from 'classnames'
import MuiCheckbox from '@material-ui/core/Checkbox'
import SvgIcon from '@material-ui/core/SvgIcon'
import moment from 'moment'

import StyleSheet from 'styles'

const CheckboxUnchecked = ({theme, className, style}) => {
  const outerStroke = (theme === 'dark') ? '#FFFFFF' : '#464646'
  return (
      <SvgIcon viewBox="0 0 23 23" className={className} style={style}>
        <rect x="0" y="0" style={{stroke: outerStroke, strokeWidth: '4px', fill: 'white', fillOpacity: 0}} id="chx_rectangle" width="23" height="23"/>
      </SvgIcon>
    )
  }

const CheckboxChecked = ({theme, className, style}) => {
  const outerStroke = (theme === 'dark') ? '#FFFFFF' : '#464646'
  return (
    <SvgIcon viewBox="0 0 23 23" className={className} style={style}>
      <rect x="6.3" y="6.3" style={{stroke: '#6AAEAA', strokeWidth: '0px', fill: '#6AAEAA', fillOpacity: 1}} id="chx_rectangle_red" width="10.4" height="10.4"/>
      <rect x="0" y="0" style={{stroke: outerStroke, strokeWidth: '4px', fill: 'white', fillOpacity: 0}} id="chx_rectangle" width="23" height="23"/>
    </SvgIcon>
  )
}

export class Checkbox extends PureComponent {
  static defaultProps = {
    theme: 'light',
    small: false,
    type: 'checkbox',
  }

  handleChange = ({target: {checked}}) => {
    if (this.props.checkedAsTime && checked) {
      checked = checked && moment().toISOString()
    }
    this.props.onChange && this.props.onChange({target: {type: this.props.type, checked: checked}})
  }

  render = () => {
    const {iconStyle = {}, theme, small, checked, checkedAsTime, onChange, helperText, ...rest} = this.props
    const classes = classnames({
      [styles.normal]: (!small),
      [styles.small]: small
    })
    return (
      <MuiCheckbox {...rest}
        checked={!!checked} onChange={this.handleChange}
        icon={ <CheckboxUnchecked theme={theme} className={classes} style={ {...iconStyle} }/> }
        checkedIcon={ <CheckboxChecked theme={theme} className={classes} style={ {...iconStyle} }/> }/>
    )
  }
}

const styles = StyleSheet({
  normal:{
    fontSize: '23px',
    width: '23px',
    height: '23px'
  },
  small: {
    fontSize: '15px',
    width: '15px',
    height: '15px'
  }
})

export default Checkbox